import { render, staticRenderFns } from "./LiteracyBadgePicker.vue?vue&type=template&id=771d5a6c"
import script from "./LiteracyBadgePicker.vue?vue&type=script&lang=js"
export * from "./LiteracyBadgePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports